import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LangRedirectGuard } from './guards/lang-redirect.guard';

const routes: Routes = [
  // Home
  {
    path: '',
    canActivate: [LangRedirectGuard],
    loadChildren: () => import('./components/pages/landing/landing.module').then(m => m.LandingModule),
    data: { title: 'home_tab_title', breadcrumb: "home" }
  },
  // library
  {
    path: 'library',
    canActivate: [LangRedirectGuard],
    loadChildren: () => import('./components/pages/home/library.module').then(m => m.LibraryModule),
    data: { title: 'library_tab_title', breadcrumb: "library" }
  },
  // About
  { path: 'about', canActivate: [LangRedirectGuard], loadChildren: () => import('./components/pages/about/about.module').then(m => m.AboutModule), data: { title: 'about_tab_title', breadcrumb: "about" } },
  // Send Feedback
  { path: 'feedback', canActivate: [LangRedirectGuard], loadChildren: () => import('./components/pages/send-feedback/send-feedback.module').then(m => m.SendFeedbackModule), data: { title: "feedback_tab_title", breadcrumb: "feedback" } },
  // suggest content
  { path: 'suggest-content', loadChildren: () => import('./components/pages/suggest-content/suggest-content.module').then(m => m.SuggestContentModule), canActivate: [LangRedirectGuard], data: { title: "suggest_content_tab_title", breadcrumb: "suggest_content" } },
  // item details
  { path: 'item/:slug', canActivate: [LangRedirectGuard], loadChildren: () => import('./components/pages/home/items/item-details/item-details.module').then(m => m.ItemDetailsModule), data: { title: "", breadcrumb: "details" } },
  // recommendations
  { path: 'recommendations', canActivate: [LangRedirectGuard], loadChildren: () => import('./components/pages/recommendations/recommendations.module').then(m => m.RecommendationsModule), data: { title: "recommendations_tab_title", breadcrumb: "recommendations" } },
  // error page
  { path: '**', loadChildren: () => import('./components/pages/error-page/error-page.module').then(m => m.ErrorPageModule), data: { breadcrumb: "Error 404" } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
